var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftMenuLogo = function SvgLeftMenuLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "LeftMenuLogo_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 870 378",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "LeftMenuLogo_svg__linear-gradient",
    x1: 135.14,
    x2: 248.25,
    y1: 185.56,
    y2: 185.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170172",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#170556",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#190d24",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1a1207",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1b1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "LeftMenuLogo_svg__linear-gradient-2",
    x1: 140.01,
    x2: 151.89,
    y1: 163.02,
    y2: 156.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170172",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#17016e",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#180163",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#190152",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1a0252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "LeftMenuLogo_svg__linear-gradient-3",
    x1: 86.29,
    x2: 113.22,
    y1: 186.15,
    y2: 186.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffdc3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fbd132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f1b617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f0b112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#LeftMenuLogo_svg__linear-gradient-3",
    id: "LeftMenuLogo_svg__linear-gradient-4",
    x1: 75.08,
    x2: 129.85,
    y1: 198.83,
    y2: 198.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#LeftMenuLogo_svg__linear-gradient-3",
    id: "LeftMenuLogo_svg__linear-gradient-5",
    x1: 106.08,
    x2: 127.28,
    y1: 219.65,
    y2: 219.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#LeftMenuLogo_svg__linear-gradient-3",
    id: "LeftMenuLogo_svg__linear-gradient-6",
    x1: 92.55,
    x2: 102.79,
    y1: 229.45,
    y2: 229.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#LeftMenuLogo_svg__linear-gradient-3",
    id: "LeftMenuLogo_svg__linear-gradient-7",
    x1: 97.74,
    x2: 131.12,
    y1: 206.74,
    y2: 206.74,
    gradientTransform: "rotate(27.24 114.438 206.761)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#LeftMenuLogo_svg__linear-gradient-3",
    id: "LeftMenuLogo_svg__linear-gradient-8",
    x1: 75.1,
    x2: 91.39,
    y1: 222.8,
    y2: 222.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#LeftMenuLogo_svg__linear-gradient",
    id: "LeftMenuLogo_svg__linear-gradient-9",
    x1: 150.79,
    x2: 191.7,
    y1: 175.02,
    y2: 175.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#LeftMenuLogo_svg__linear-gradient",
    id: "LeftMenuLogo_svg__linear-gradient-10",
    x1: 135.14,
    x2: 185.84,
    y1: 158.11,
    y2: 158.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "LeftMenuLogo_svg__linear-gradient-11",
    x1: 135.11,
    x2: 248.37,
    y1: 167.74,
    y2: 167.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffdc3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#facf30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f4be1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f1b415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f0b112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "LeftMenuLogo_svg__linear-gradient-12",
    x1: 222.63,
    x2: 175.38,
    y1: 173.83,
    y2: 121.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170172",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#0a0035",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "LeftMenuLogo_svg__radial-gradient",
    cx: 322.54,
    cy: 178.5,
    r: 61.81,
    fx: 322.54,
    fy: 178.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffdc3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fbd132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f1b617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f0b112"
  })), /*#__PURE__*/React.createElement("style", null, ".LeftMenuLogo_svg__cls-2{fill:#122a80}.LeftMenuLogo_svg__cls-3{fill:#5b6eab}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.1 241.96h-33.31l-37.47-45.61-45.17 45.61v-23.83c0-14.65 8.92-28.46 22.62-36.39l90.48-52.57-97.2 43.61c-7.45 3.32-15.9-1.89-15.9-9.37V83.74h69.08c24.52 0 44.41 22.77 44.41 50.86s-19.88 50.86-44.41 50.86zM223.94 134c-.49-11.98-9.13-22-19.71-22h-44.41v33.66z",
    className: "LeftMenuLogo_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.66 178.5c0 35.05-26.92 63.46-60.12 63.46s-60.12-28.41-60.12-63.46 26.91-63.46 60.12-63.46 60.12 28.41 60.12 63.46m-22.27 0c0-22.75-16.94-41.19-37.85-41.19s-37.85 18.44-37.85 41.19 16.95 41.19 37.85 41.19 37.85-18.44 37.85-41.19",
    style: {
      fill: "url(#LeftMenuLogo_svg__radial-gradient)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.28 177.97c0 27.83-21.37 50.39-47.74 50.39s-47.74-22.56-47.74-50.39 21.37-50.39 47.74-50.39 47.74 22.56 47.74 50.39m-17.68 0c0-18.06-13.46-32.71-30.05-32.71s-30.06 14.64-30.06 32.71 13.46 32.71 30.06 32.71 30.05-14.64 30.05-32.71M512.67 192.51c0 27.31-19.74 49.44-44.1 49.44h-71.82V83.74h69.42c21.51.08 38.93 19.66 38.93 43.79 0 10.19-3.1 19.56-8.31 27 9.69 9.07 15.87 22.72 15.87 37.98Zm-90.72-80.52v31.08h44.1c7.65 0 13.86-6.96 13.86-15.54s-6.21-15.54-13.86-15.54zm65.52 80.52c0-11.7-8.46-21.19-18.9-21.19h-46.62v42.38h46.62c10.44 0 18.9-9.49 18.9-21.19M532.67 241.96V86.15h23.76v155.81zM675.42 212.93v27.82h-95.05V84.95h23.76v127.98zM794.41 214.13v27.82h-95.05V86.15h23.76v127.98z",
    className: "LeftMenuLogo_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m180.32 196.35-45.17 45.61v-23.83c0-14.65 8.92-28.46 22.62-36.39l90.48-52.57",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12 149.99s7.82 8.25 16.76 22.43c.1.17.33-.19.64-.91 3.99-9.25-2.1-19.74-12.09-21.03l-3.79-.49z",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-2)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.05 296.76c-1.27 1.68-2.81 3.05-4.63 4.09s-4.19 1.57-7.12 1.57c-3.79 0-6.84-1.35-9.15-4.04s-3.46-6.49-3.46-11.39c0-4.27 1.05-7.76 3.14-10.45s5.16-4.04 9.2-4.04q5.13 0 8.1 2.82c1.98 1.88 3.1 4.5 3.35 7.86.11 1.27.13 2.6.08 4h-19.42c0 3.2.73 5.95 2.2 8.25s3.47 3.45 6.01 3.45c1.84 0 3.45-.38 4.83-1.15s2.65-1.91 3.81-3.43l3.06 2.47Zm-12.07-20.92c-2.52 0-4.43.86-5.71 2.59s-1.98 3.68-2.07 5.86h15.05c-.07-2.31-.64-4.29-1.72-5.96q-1.605-2.49-5.55-2.49M175.57 259.91h4.24v36.11c0 1.09.21 1.83.64 2.23.43.39 1.18.59 2.25.59.14 0 .35 0 .63-.03.28-.02.56-.04.84-.08l.62 2.47c-.32.14-.68.29-1.07.43s-.81.27-1.23.39q-.645.18-1.29.27c-.43.06-.83.09-1.21.09-1.4 0-2.48-.45-3.26-1.34s-1.17-2.23-1.17-4v-37.13ZM223 296.76c-1.27 1.68-2.81 3.05-4.63 4.09s-4.19 1.57-7.12 1.57c-3.79 0-6.84-1.35-9.15-4.04s-3.46-6.49-3.46-11.39c0-4.27 1.05-7.76 3.14-10.45s5.16-4.04 9.2-4.04q5.13 0 8.1 2.82c1.98 1.88 3.1 4.5 3.35 7.86.11 1.27.13 2.6.08 4h-19.42c0 3.2.73 5.95 2.2 8.25s3.47 3.45 6.01 3.45c1.84 0 3.45-.38 4.83-1.15s2.65-1.91 3.81-3.43l3.06 2.47Zm-12.07-20.92c-2.52 0-4.43.86-5.71 2.59s-1.98 3.68-2.07 5.86h15.05c-.07-2.31-.64-4.29-1.72-5.96q-1.605-2.49-5.55-2.49M263.3 297.17a11.87 11.87 0 0 1-4.16 3.8c-1.7.94-3.93 1.41-6.68 1.41-4.02 0-7.23-1.4-9.6-4.2-2.38-2.8-3.57-6.41-3.57-10.82s1.19-7.84 3.58-10.64 5.6-4.2 9.64-4.2c2.41 0 4.38.36 5.89 1.09 1.51.72 2.77 1.69 3.77 2.91l-2.76 2.52c-.93-1.2-1.95-2.07-3.07-2.6-1.12-.54-2.46-.8-4.01-.8-2.61 0-4.69 1.06-6.25 3.18s-2.33 4.82-2.33 8.11.83 6.3 2.49 8.69c1.66 2.4 3.74 3.59 6.22 3.59 2.07 0 3.68-.36 4.81-1.09s2.15-1.72 3.05-2.99zM276.5 272.97h4.18v-7.32h4.24v7.32h7.06l-.46 3.68h-6.6v16.74c0 1.66.27 3 .82 4s1.4 1.5 2.56 1.5c.63 0 1.41-.09 2.36-.28s1.57-.33 1.88-.42l.32 3.68c-.36.07-1.11.18-2.27.34-1.15.15-2.06.23-2.72.23-2.27 0-4.04-.56-5.3-1.69s-1.89-3.21-1.89-6.25v-17.84h-4.18v-3.68ZM312.8 272.97c.13.47.22 1.09.28 1.86.06.78.09 1.79.09 3.05 1.38-1.65 2.99-2.95 4.84-3.92 1.85-.96 3.78-1.45 5.78-1.45.23 0 .48.02.74.05.26.04.45.07.58.11l-.91 4.43q-.81-.21-2.04-.21c-2.38 0-4.35.54-5.93 1.61-1.57 1.07-2.58 2.13-3.03 3.17v20.28h-4.24v-24.98c-.04-2.31-.09-3.64-.16-4zM352.62 302.43c-4.54 0-7.98-1.4-10.3-4.21s-3.49-6.53-3.49-11.16c0-4.15 1.24-7.61 3.73-10.38s5.79-4.16 9.93-4.16 7.48 1.44 9.78 4.32 3.45 6.47 3.45 10.76-1.21 7.57-3.62 10.48-5.57 4.36-9.47 4.36Zm-.19-3.41c1.48 0 2.78-.35 3.89-1.05s2.21-1.96 3.31-3.78 1.65-4.3 1.65-7.43c0-2.74-.76-5.23-2.27-7.47s-3.72-3.37-6.64-3.37-5.16 1.07-6.75 3.22c-1.58 2.15-2.37 4.95-2.37 8.42 0 2.97.57 5.28 1.7 6.92 1.14 1.65 2.28 2.81 3.43 3.5s2.5 1.03 4.04 1.03ZM383.74 276.7c0-1.16-.08-2.41-.24-3.73h4.1c.16.79.27 1.65.32 2.58 1.23-.81 2.74-1.51 4.52-2.12s3.55-.91 5.33-.91c2.74 0 4.9.8 6.51 2.39 1.6 1.59 2.4 3.85 2.4 6.79v20.25h-4.24v-19.9c0-1.74-.46-3.18-1.37-4.33s-2.2-1.73-3.86-1.73-3.31.25-4.94.75-3.06 1.15-4.29 1.93v23.28h-4.24v-25.24ZM425.32 263.58c0-.64.23-1.23.7-1.77s1.08-.8 1.85-.8 1.35.27 1.81.8.68 1.13.68 1.77c0 .73-.25 1.35-.75 1.84s-1.08.74-1.74.74-1.27-.25-1.78-.74-.76-1.1-.76-1.84Zm.43 9.39h4.24v28.97h-4.24zM471.74 297.17a11.87 11.87 0 0 1-4.16 3.8c-1.7.94-3.93 1.41-6.68 1.41-4.02 0-7.23-1.4-9.6-4.2-2.38-2.8-3.57-6.41-3.57-10.82s1.19-7.84 3.58-10.64 5.6-4.2 9.64-4.2c2.41 0 4.38.36 5.89 1.09 1.51.72 2.77 1.69 3.77 2.91l-2.76 2.52c-.93-1.2-1.95-2.07-3.07-2.6-1.12-.54-2.46-.8-4.01-.8-2.61 0-4.69 1.06-6.25 3.18s-2.33 4.82-2.33 8.11.83 6.3 2.49 8.69c1.66 2.4 3.74 3.59 6.22 3.59 2.07 0 3.68-.36 4.81-1.09s2.15-1.72 3.05-2.99zM526.47 263.58c0-.64.23-1.23.7-1.77s1.08-.8 1.85-.8 1.35.27 1.81.8.68 1.13.68 1.77c0 .73-.25 1.35-.75 1.84s-1.08.74-1.74.74-1.27-.25-1.78-.74-.76-1.1-.76-1.84Zm.43 9.39h4.24v28.97h-4.24zM550.4 276.7c0-1.16-.08-2.41-.24-3.73h4.1c.16.79.27 1.65.32 2.58 1.23-.81 2.74-1.51 4.52-2.12s3.55-.91 5.33-.91c2.74 0 4.9.8 6.51 2.39 1.6 1.59 2.4 3.85 2.4 6.79v20.25h-4.24v-19.9c0-1.74-.46-3.18-1.37-4.33s-2.2-1.73-3.86-1.73-3.31.25-4.94.75-3.06 1.15-4.29 1.93v23.28h-4.24v-25.24ZM600.87 297.65l7.46-24.68h4.56l-10.03 28.97h-4.16l-10.14-28.97h4.56zM641.03 302.43c-4.54 0-7.98-1.4-10.3-4.21s-3.49-6.53-3.49-11.16c0-4.15 1.24-7.61 3.73-10.38s5.79-4.16 9.93-4.16 7.48 1.44 9.78 4.32 3.45 6.47 3.45 10.76-1.21 7.57-3.62 10.48-5.57 4.36-9.47 4.36Zm-.19-3.41c1.48 0 2.78-.35 3.89-1.05s2.21-1.96 3.31-3.78 1.65-4.3 1.65-7.43c0-2.74-.76-5.23-2.27-7.47s-3.72-3.37-6.64-3.37-5.16 1.07-6.75 3.22c-1.58 2.15-2.37 4.95-2.37 8.42 0 2.97.57 5.28 1.7 6.92 1.14 1.65 2.28 2.81 3.43 3.5s2.5 1.03 4.04 1.03ZM671.91 263.58c0-.64.23-1.23.7-1.77s1.08-.8 1.85-.8 1.35.27 1.81.8.68 1.13.68 1.77c0 .73-.25 1.35-.75 1.84s-1.08.74-1.74.74-1.27-.25-1.78-.74-.76-1.1-.76-1.84Zm.43 9.39h4.24v28.97h-4.24zM718.32 297.17a11.87 11.87 0 0 1-4.16 3.8c-1.7.94-3.93 1.41-6.68 1.41q-6.03 0-9.6-4.2c-2.38-2.8-3.57-6.41-3.57-10.82s1.19-7.84 3.58-10.64 5.6-4.2 9.64-4.2c2.41 0 4.38.36 5.89 1.09 1.51.72 2.77 1.69 3.77 2.91l-2.76 2.52c-.93-1.2-1.95-2.07-3.07-2.6s-2.45-.8-4.01-.8c-2.61 0-4.69 1.06-6.25 3.18s-2.34 4.82-2.34 8.11.83 6.3 2.5 8.69 3.74 3.59 6.22 3.59c2.07 0 3.68-.36 4.82-1.09 1.14-.72 2.15-1.72 3.05-2.99l2.98 2.04ZM758.22 296.76a15.2 15.2 0 0 1-4.63 4.09c-1.82 1.05-4.19 1.57-7.12 1.57-3.79 0-6.84-1.35-9.15-4.04s-3.46-6.49-3.46-11.39c0-4.27 1.05-7.76 3.14-10.45s5.16-4.04 9.2-4.04q5.13 0 8.1 2.82c1.99 1.88 3.1 4.5 3.35 7.86.11 1.27.13 2.6.08 4h-19.42c0 3.2.73 5.95 2.2 8.25s3.47 3.45 6.01 3.45c1.84 0 3.45-.38 4.83-1.15s2.65-1.91 3.81-3.43l3.06 2.47Zm-12.07-20.92c-2.52 0-4.43.86-5.71 2.59-1.29 1.73-1.98 3.68-2.07 5.86h15.05c-.07-2.31-.65-4.29-1.72-5.96q-1.605-2.49-5.55-2.49M776.41 294.94c1.22 1.32 2.47 2.35 3.75 3.08 1.29.73 2.91 1.1 4.86 1.1s3.58-.42 4.86-1.25c1.27-.83 1.9-1.97 1.9-3.42 0-1-.32-1.86-.97-2.59s-1.94-1.43-3.89-2.13c-.73-.25-2.17-.74-4.32-1.48-2.02-.54-3.92-1.45-5.69-2.74s-2.65-3.11-2.65-5.47.96-4.07 2.87-5.46 4.39-2.08 7.43-2.08c1.07 0 2.07.06 2.99.17s1.79.31 2.6.58 1.58.62 2.31 1.05c.72.43 1.42.97 2.11 1.61l-2.44 2.92c-1.22-1.06-2.4-1.82-3.55-2.31q-1.725-.72-3.96-.72c-1.82 0-3.33.34-4.52 1.02s-1.78 1.67-1.78 2.98.55 2.25 1.66 2.99 2.42 1.34 3.94 1.78c.8.25 1.6.51 2.39.78s1.58.53 2.39.78c2.54.91 4.36 1.99 5.47 3.22s1.66 2.85 1.66 4.86c0 2.5-1.03 4.5-3.09 5.98-2.06 1.49-4.6 2.23-7.62 2.23-2.36 0-4.45-.3-6.26-.9-1.82-.6-3.57-1.77-5.27-3.53l2.82-3.06Z",
    className: "LeftMenuLogo_svg__cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m91.08 194.31 20.35-10.49a3.285 3.285 0 0 0 1.42-4.42 3.285 3.285 0 0 0-4.42-1.42l-20.35 10.49a3.285 3.285 0 0 0-1.42 4.42 3.285 3.285 0 0 0 4.42 1.42",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.87 214.17 48.2-24.84a3.285 3.285 0 0 0 1.42-4.42 3.285 3.285 0 0 0-4.42-1.42l-48.2 24.84a3.285 3.285 0 0 0-1.42 4.42 3.285 3.285 0 0 0 4.42 1.42",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.49 212.97-14.63 7.54a3.285 3.285 0 0 0-1.42 4.42 3.285 3.285 0 0 0 4.42 1.42l14.63-7.54a3.285 3.285 0 0 0 1.42-4.42 3.285 3.285 0 0 0-4.42-1.42",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98 225.58-3.67 1.89a3.285 3.285 0 0 0-1.42 4.42 3.285 3.285 0 0 0 4.42 1.42l3.67-1.89a3.285 3.285 0 0 0 1.42-4.42 3.285 3.285 0 0 0-4.42-1.42",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34 203.45h30.19c1.79 0 3.25 1.46 3.25 3.25v.06c0 1.8-1.46 3.25-3.25 3.25H99.34a3.25 3.25 0 0 1-3.25-3.25v-.06c0-1.8 1.46-3.25 3.25-3.25",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-7)"
    },
    transform: "rotate(-27.24 114.44 206.746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.6 217.38-9.72 5.01a3.285 3.285 0 0 0-1.42 4.42 3.285 3.285 0 0 0 4.42 1.42l9.72-5.01a3.285 3.285 0 0 0 1.42-4.42 3.285 3.285 0 0 0-4.42-1.42",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.79 186.62 40.9-18.88-2.4-4.32-31.53 18.32a49.4 49.4 0 0 0-6.97 4.88",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.04 172.78 34.79-15.61-8.19-14.76-17.84 3.24-24.67 4.32v13.43c0 7.48 8.45 12.69 15.9 9.37Z",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.37 129.3-113.26 20.67h.08-.07.07c.46.03 10.9.83 14.98 6.8 6.25 9.13 1.71 15.64 1.71 15.64l56.42-22.35-50.53 31.67s8.53-.17 14.06 9.33c3.61 6.21-1.22 15.1-1.22 15.1l77.77-76.87Z",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.63 134.6c0-1.9-.1-3.77-.28-5.61l-.25.25.14-.06-.18.11-67.75 67.07 37.47 45.61h33.31l-46.87-56.5c24.52 0 44.41-22.77 44.41-50.86Z",
    style: {
      fill: "url(#LeftMenuLogo_svg__linear-gradient-12)"
    }
  }));
};
export default SvgLeftMenuLogo;